import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { sliderService } from 'api/services/slider'
import { SliderItem } from 'api/types/slider'
import { useContext, useEffect, useState } from 'react'
import { Button, toast } from 'keep-react'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from 'contexts/AuthContext'

const CustomSlider = () => {
  const { currentBroker } = useContext(AuthContext)
  const [slides, setSlides] = useState<SliderItem[] | null>(null)
  const navigate = useNavigate()
  const primeSlide = slides?.find(slide => slide.id === 6)

  const getSliderList = async () => {
    try {
      const response = (await sliderService.getSliderList()) as SliderItem[]

      setSlides(response)
    } catch (error) {
      console.error('Error fetching sliders:', error)
      toast.error('Não foi possível carregar os sliders.')
    }
  }

  useEffect(() => {
    getSliderList()
  }, [])

  if (!slides || slides.length === 0) {
    return <></>
  }

  return (
    <>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation={{
          nextEl: '.custom-swiper-button-next',
          prevEl: '.custom-swiper-button-prev',
        }}
        pagination={{
          clickable: true,
          el: '.custom-pagination',
          bulletClass:
            'bg-transparent border border-white rounded-full w-2.5 h-2.5 cursor-pointer',
          bulletActiveClass: '!bg-white',
        }}
        autoplay={{ delay: 8000 }}
        loop={true}
        className="w-full aspect-panorama h-auto relative"
      >
        {!currentBroker?.IsPrimePartner &&
          slides
            .filter(slide => slide.id !== 6)
            .map((slide, index) => {
              if (
                !slide.files ||
                slide.files.length === 0 ||
                slide.title === null
              )
                return false
              return (
                <SwiperSlide
                  key={index}
                  className="relative aspect-panorama w-full"
                >
                  <img
                    src={slide.files[0].uri}
                    alt={slide.title}
                    className="absolute top-0 left-0 w-full h-full object-cover rounded-lg"
                  />

                  <div className="relative w-[40%] ml-[50%] p-4 text-white h-full flex items-center">
                    <div
                      className={`${currentBroker?.IsPrimePartner ? 'bg-prime/50' : 'bg-primary-600/50'} p-4 flex flex-col justify-center backdrop-blur-sm rounded-lg w-full max-h-full overflow-hidden`}
                    >
                      <h3 className="text-lg font-bold uppercase pb-6">
                        {slide.title}
                      </h3>
                      <p className="text-sm pb-4">{slide.content}</p>
                      {slide.link && (
                        <div>
                          <Button
                            variant="link"
                            onClick={() => navigate(slide.link)}
                            className="p-0 text-white font-bold"
                          >
                            SABER MAIS +
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              )
            })}

        {currentBroker?.IsPrimePartner &&
          primeSlide &&
          primeSlide.files &&
          primeSlide.files.length > 0 &&
          primeSlide.title !== null && (
            <SwiperSlide
              key="PrimeSlide"
              className="relative aspect-panorama w-full"
            >
              <img
                src={primeSlide.files[0].uri}
                alt={primeSlide.title}
                className="absolute top-0 left-0 w-full h-full object-cover rounded-lg"
              />

              <div className="relative w-[40%] ml-[50%] p-4 text-white h-full flex items-center">
                <div
                  className={`${currentBroker?.IsPrimePartner ? 'bg-prime/50' : 'bg-primary-600/50'} p-4 flex flex-col justify-center backdrop-blur-sm rounded-lg w-full max-h-full overflow-hidden`}
                >
                  <h3 className="text-lg font-bold uppercase pb-6">
                    {primeSlide.title}
                  </h3>
                  <p className="text-sm pb-4">{primeSlide.content}</p>
                  {primeSlide.link && (
                    <div>
                      <Button
                        variant="link"
                        onClick={() => navigate(primeSlide.link)}
                        className="p-0 text-white font-bold"
                      >
                        SABER MAIS +
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </SwiperSlide>
          )}

        <div className="custom-swiper-button-prev absolute left-2 top-1/2 transform -translate-y-1/2 text-white text-2xl z-10 cursor-pointer">
          ❮
        </div>
        <div className="custom-swiper-button-next absolute right-2 top-1/2 transform -translate-y-1/2 text-white text-2xl z-10 cursor-pointer">
          ❯
        </div>
        <div className="custom-pagination absolute !bottom-5 !left-0 z-10 flex justify-center gap-2"></div>
      </Swiper>
      <span className="hidden bg-transparent border border-white rounded-full w-2.5 h-2.5 cursor-pointer"></span>
    </>
  )
}

export default CustomSlider
